// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__bc-V5","buttons":"RemoveExpirationActionButtons_buttons__25Ohb"};